//@flow
//Action Type Registered
export const ATHENA_INV_SUBMIT_SUCCESS='ATHENA_INV_SUBMIT_SUCCESS'
export const ATHENA_INV_SUBMIT_ERROR='ATHENA_INV_SUBMIT_ERROR'
export const ATHENA_INV_SUBMITTED_COMPLETED='ATHENA_INV_SUBMITTED_COMPLETED'
export const ATHENA_EDIT_VERIFY_FORM_DATA_SUCCESS='ATHENA_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const ATHENA_EDIT_VERIFY_FORM_DATA_ERROR='ATHENA_EDIT_VERIFY_FORM_DATA_ERROR'
export const ATHENA_UPDATE_FORM_ERROR='ATHENA_UPDATE_FORM_ERROR'
export const REFRESH_ATHENA_VENDORS_SUCCESS='REFRESH_ATHENA_VENDORS_SUCCESS'
export const REFRESH_ATHENA_VENDORS_ERROR='REFRESH_ATHENA_VENDORS_ERROR'
export const GET_ATHENA_ITEMS_SUCCESS='GET_ATHENA_ITEMS_SUCCESS';
export const GET_ATHENA_ITEMS_ERROR='GET_ATHENA_ITEMS_ERROR';
export const CREATE_NEW_ATHENA_ITEM_SUCCESS='CREATE_NEW_ATHENA_ITEM_SUCCESS';
export const CREATE_NEW_ATHENA_ITEM_ERROR='CREATE_NEW_ATHENA_ITEM_ERROR';
export const EDIT_ATHENA_ITEM='EDIT_ATHENA_ITEM';
export const UPDATE_ATHENA_ITEM_SUCCESS='UPDATE_ATHENA_ITEM_SUCCESS';
export const UPDATE_ATHENA_ITEM_ERROR='UPDATE_ATHENA_ITEM_ERROR';
export const MOVE_DOWN_ATHENA_ITEM_SUCCESS='MOVE_DOWN_ATHENA_ITEM_SUCCESS';
export const MOVE_DOWN_ATHENA_ITEM_ERROR='MOVE_DOWN_ATHENA_ITEM_ERROR';
export const MOVE_UP_ATHENA_ITEM_SUCCESS='MOVE_UP_ATHENA_ITEM_SUCCESS';
export const MOVE_UP_ATHENA_ITEM_ERROR='MOVE_UP_ATHENA_ITEM_ERROR';
export const DELETE_ATHENA_ITEM_SUCCESS='DELETE_ATHENA_ITEM_SUCCESS';
export const DELETE_ATHENA_ITEM_ERROR='DELETE_ATHENA_ITEM_ERROR';
export const SELECTED_ATHENA_ITEM_ID='SELECTED_ATHENA_ITEM_ID';
export const REFRESH_ATHENA_ITEM='REFRESH_ATHENA_ITEM';
export const OPEN_ADD_EDIT_LINEITEM_FORM='ATHENA_OPEN_ADD_EDIT_LINEITEM_FORM'
export const CANCEL_ADD_EDIT_LINEITEN_FORM='ATHENA_CANCEL_ADD_EDIT_LINEITEN_FORM'


// WEBPACK FOOTER //
// ./src/redux/athena/actionTypes.js